"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullWidthImageFullScreenOptionField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class FullWidthImageFullScreenOptionField extends EditorFieldBase_1.EditorFieldBase {
}
exports.FullWidthImageFullScreenOptionField = FullWidthImageFullScreenOptionField;
